<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">任务订单</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="任务店铺" prop="shopInfo">
              <el-select v-model="queryForm.shopInfo" clearable placeholder="请选择任务类型">
                <el-option
                    v-for="item in allShops"
                    :key="item.id"
                    :label="item.shopName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="任务类型" prop="tasktype">
              <el-select v-model="queryForm.tasktype" clearable placeholder="请选择任务类型">
                <el-option
                    v-for="item in allTaskTypes"
                    :key="item.id"
                    :label="item.taskName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="任务编号" prop="taskId">
              <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="网店订单号" prop="plateordernum">
              <el-input v-model="queryForm.plateordernum" placeholder="请输入编号"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="订单编号" prop="orderNum">
              <el-input v-model="queryForm.orderNum" placeholder="请输入系统订单编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="买手编号" prop="customerId">
              <el-input v-model="queryForm.customerId" placeholder="请输入编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="接单账号" prop="plateformUsername">
              <el-input v-model="queryForm.plateformUsername" placeholder="请输入账号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="追评状态" prop="reviewstatus">
              <el-select v-model="queryForm.reviewstatus" clearable placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.reviewStatus"
                    :label="item.reviewStatus"
                    :value="item.reviewStatus"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="9">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否获取" prop="expressStatus">
              <el-select v-model="queryForm.expressStatus" clearable placeholder="请选择">
                <el-option
                    v-for="item in expressStatus"
                    :key="item.expressValue"
                    :label="item.expressValue"
                    :value="item.expressValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="margin: 20px">
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="handleOpt()">批量确认发货
        </el-button>
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="getExpressInfo()">获取运单号
        </el-button>
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="handleOpt()">导出修改地址
        </el-button>
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="handleOpt()">导入修改地址
        </el-button>
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="handleOpt()">导入平台订单(淘宝/京东/拼多多)
        </el-button>
        <el-button type="success" size="small" style="margin: 10px 20px 0 0"
                   @click="handleOpt()">同步运单号
        </el-button>
        <el-table :data="tableData"
                  ref="table"
                  border default-expand-all
                  :max-height="tableHeight"
                  style="width: 100%;margin-top: 20px"
                  @selection-change="handleSelectionChange">
          <el-table-column label="全选" width="50" type="selection"/>
          <el-table-column
              v-for="(it, index) in tableFeildAndVal" :key="index"
              :label="it.lable"
              :prop="it.key"
              :sortable="it.sortable"
              min-width="15%" align="center">
            <template slot-scope="scope">
        <span v-if="scope.column.property == 'taskNum'">
          <el-button type="text"
                     @click="goToTask(scope.row[scope.column.property])">{{ scope.row[scope.column.property] }}</el-button>
        </span>
              <span v-else-if="scope.column.property == 'orderNum'">
          <el-button type="text"
                     @click="goToOrder(scope.row[scope.column.property])">{{ scope.row[scope.column.property] }}</el-button>
        </span>
              <span v-else v-html="scope.row[scope.column.property]">
        </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px; margin-top: 20px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="dialogForm" ref="dialogForm" label-width="100px">
        <el-form-item label="物流信息：">
          <el-select v-model="dialogForm.expressInfo" clearable placeholder="请选择物流">
            <el-option
                v-for="item in expressOptions"
                :key="item.id"
                :label="item.expressManage"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm" size="mini" type="primary">获取单号</el-button>
      </div>
    </el-dialog>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getOrderExpressList, updateExpressInfo} from "../../api/b2cbusiness/b2c_orderlist";
import {getStrEndWithNumbers} from "../../lib/utils";
import {getExpressUserManageList, updateExpressUserManage} from "../../api/b2cbusiness/b2c_express";
import {getShops} from "../../api/b2cbusiness/b2c_shopmanage";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "OrderExpresslist",
  components: {CustomerServiceComponent},
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      tableFeildAndVal: [
        {
          key: "orderTime",
          sortable: true,
          lable: "接单时间"
        },
        {
          key: "taskNum",
          sortable: false,
          lable: "任务编号"
        },
        {
          key: "orderNum",
          sortable: true,
          lable: "订单编号"
        },
        {
          key: "customerId",
          sortable: false,
          lable: "买手编号"
        },
        {
          key: "shopName",
          sortable: false,
          lable: "任务店铺"
        },
        {
          key: "orderInfo",
          sortable: false,
          lable: "接单信息"
        },
        {
          key: "expressNumbers",
          sortable: false,
          lable: "运单号"
        },
        {
          key: "addressInfo",
          sortable: false,
          lable: "地址"
        },
        {
          key: "retMoneyStatus",
          sortable: false,
          lable: "返款状态"
        },
        {
          key: "orderStatus",
          sortable: false,
          lable: "订单状态"
        }
      ],
      allShops: [],
      allTaskTypes:[],
      tableData: [
      ],
      options:[
        {
          reviewStatus:"已追评",
        },
        {
          reviewStatus:"未追评",
        }
      ],
      expressStatus:[
        {
          expressValue:"已获取",
        },
        {
          expressValue:"未获取",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm: {},
      dialogFormVisible: false,
      dialogTitle:"",
      dialogRefName:"dialogForm",
      dialogForm: {
        expressInfo:""
      },
      expressOptions:[],
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  computed:{
    /*changeTaskNum(){
      return function (taskOrOrderNum) {
        return getStrEndWithNumbers(taskOrOrderNum, 8);
      }
    }

     */
  },
  mounted() {
    getShops({shopNum:null,
      shopName:null,
      shopUsername:null,
      shopType: null,
      shopMajorTypeId:null,
      status:null,
      shopGroup:null}).then(res=>{
      if (res.success){
        console.log(res.data)
        this.allShops = res.data;
      }
    });

    getAllTaskType().then(res => {
      console.log(res.data)
      this.allTaskTypes = res.data;
    });
    this.getData();
    getExpressUserManageList({id:null, b2cExpressManageId:null}, this.pagination).then(res=>{
      if (res.success){
        this.expressOptions = res.data.records;
      }
    });
  },
  methods: {
    submitDialogForm(){
      let b2cOrder = {};
      b2cOrder.id  = this.multipleSelection[0].orderId;
      b2cOrder.expressNumbers = this.dialogForm.expressInfo.b2cExpressManageId;
      updateExpressUserManage(this.dialogForm.expressInfo).then(res=>{
        if (res.success){
          updateExpressInfo(b2cOrder).then(res1=>{
            if (res1.success){
              this.$message("获取运单号成功");
              this.dialogFormVisible = false;
              this.getData();
            }
          });
        }
      });
    },
    getExpressInfo(){
      if (this.multipleSelection.length > 0){
        this.dialogFormVisible = true;
        this.dialogTitle = "选择物流"
        this.resetDialogForm()
      }else{
        this.$message("请选择要操作的订单");
      }
    },
    getData() {
      getOrderExpressList(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    goToTask(taskNum){
      console.log(taskNum)
      this.$router.push({path:'/home/businesstaskdetails', query: {b2cTaskId:taskNum}});
    },
    goToOrder(orderNum){
      console.log(orderNum)
      this.$router.push({path:'/home/taskorderdetail', query:{taskNumbers:orderNum}});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self {
  position: relative;
  width: 100%;
  margin-top: 10px;
}
</style>
